export const onboardingPaywallSectionTimerTime = 10;
